module.exports = __webpack_public_path__ + "media/images/common/ovice_logo-90e0f0ba384a184d56c16097bd19a9a9.svg";